const NAME = 'PROGRAM_ORGANIZATIONS';

export const REQUEST_PROGRAM_ORGANIZATIONS = `${NAME}/REQUEST_PROGRAM_ORGANIZATIONS`;
export const REQUEST_PROGRAM_ORGANIZATIONS_SUCCESS = `${NAME}/REQUEST_PROGRAM_ORGANIZATIONS_SUCCESS`;
export const REQUEST_PROGRAM_ORGANIZATIONS_FAILED = `${NAME}/REQUEST_PROGRAM_ORGANIZATIONS_FAILED`;
export const RESET = `${NAME}/RESET`;
